import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Packages from "../components/Packages";
import MyPackage from "../components/MyPackage";
import Footer from "../components/Footer";
import Analytics from "../components/GoogleAnalytics";

const PackagePage = () => {
  const navigate = useNavigate();
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isSession, setSession] = useState(null);

  const handleSelectPackage = (pkg) => {
    setSelectedPackage(pkg);
    navigate("/payment-method", { state: { selectedPackage: pkg } });
  };

  useEffect(() => {
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    if (sessionUser && sessionUser.payLoad.access_token) {
      setSession(sessionUser.payLoad.user);
    }
  }, []);

  // Check if isSession is not null and if userPackages is defined
  return (
    <div>
      <Analytics />
      {isSession &&
      isSession.userPackages &&
      isSession.userPackages.packageName ? (
        <MyPackage packageId={isSession.userPackages.packageName.Id} />
      ) : (
        <Packages onSelectPackage={handleSelectPackage} />
      )}
      <div style={{ marginTop: "100px" }}>
        <Footer />
      </div>
    </div>
  );
};

export default PackagePage;
